import { NavigationLink } from '@domgen/dgx-fe-common';
import { PopularVideoItem } from './cms-popular-video-item.interface';

export interface PopularVideos {
  '@path': string;
  '@name': string;
  popularVideosBody: string;
  popularVideosTitle: string;
  popularVideos: PopularVideoItem[];
  viewAllVideosLink: NavigationLink;
}
